import { UsuarioComisionFreelanceHistoricoService } from './../../../_services/usuario-comision-freelance-historico.service';
import { CanalComunicacion } from './../../../_enums/enum';
import { ComunicationComponentsService } from './../../../_services/comunication-components.service';
import { UsuarioProceso } from './../../../_models/usuario-proceso';
import { ListaService } from './../../../_services/lista.service';
import { UsuariosProcesosService } from './../../../_services/usuarios-procesos.service';
import { UsuarioComisionFreelance } from './../../../_models/usuario-comision-freelance';
import { UsuarioComisionFreelanceService } from './../../../_services/usuario-comision-freelance.service';
import { NavService } from './../../../_services/_nav.service';
import { ListaItem } from "./../../../_models/lista-item";
import { Component, OnInit } from "@angular/core";
import { ConfirmationService, SelectItem } from "primeng/api";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import { sleep } from './../../../utils/utilidades';
import { UsuarioComisionFreelanceHistorico } from './../../../_models/usuario-comision-freelance-historico';

@Component({
  selector: "app-comision-freelance-editar",
  templateUrl: "./comision-freelance-editar.component.html",
  styleUrls: ["./comision-freelance-editar.component.css"],
})
export class ComisionFreelanceEditarComponent implements OnInit {
  carInformacionInicial = true;
  tabSeleccionado = "INFO";
  lisUsuariosFreelanceTodos: UsuarioProceso[] = [];
  lisUsuariosFreelance: SelectItem[] = [];
  lisBasesFreelanceTodos: ListaItem[] = [];
  lisBasesFreelance: SelectItem[] = [];
  formulario: FormGroup;
  comisionFreelance: UsuarioComisionFreelance;
  lisUsuarioComisionFreelanceHistorico: UsuarioComisionFreelanceHistorico[] = [];
  submitted = false;
  guardando = false;

  constructor(
    private fb: FormBuilder,
    private comisionFreelanceService: UsuarioComisionFreelanceService,
    private navService: NavService,
    private location: Location,
    private conServicio: ConfirmationService,
    private route: ActivatedRoute,
    private usuarioProcesoService: UsuariosProcesosService,
    private lisService: ListaService,
    private communicationService: ComunicationComponentsService,
    private usuariosComisionesFreelanceHistoricosService: UsuarioComisionFreelanceHistoricoService) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params['id'] !== '' && params['id'] !== null && params['id'] !== undefined) {
        this.comisionFreelanceService
          .obtenerPorId(params['id'])
          .subscribe((comisionFreelance) => {
            this.comisionFreelance = comisionFreelance;
            this.cargarInformacionInicial();

          });
      } else {
        this.cargarInformacionInicial();
      }
    });
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idUsuarioComisionFreelance: [this.comisionFreelance ? this.comisionFreelance.idUsuarioComisionFreelance : null],
      idUsuarioFreelance: [this.comisionFreelance ? this.comisionFreelance.idUsuarioFreelance : null, [Validators.required]],
      porcentajeComision: [this.comisionFreelance ? this.comisionFreelance.porcentajeComision : null, [Validators.required]],
      idBaseFreelance: [this.comisionFreelance ? this.comisionFreelance.idBaseFreelance : null, [Validators.required]],
      indicadorHabilitado: [this.comisionFreelance ? this.comisionFreelance.indicadorHabilitado : true, [Validators.required]]
    })
  }

  cargarInformacionInicial() {
    forkJoin(
      this.lisService.getMasterDetails('ListasBasesFreelance'),
      this.usuarioProcesoService.listadoUsuariosFreelanceHabilitados()
    ).subscribe(([lisBasesFreelance, lisUsuariosFreelance]) => {
      this.lisBasesFreelanceTodos = lisBasesFreelance;
      this.lisUsuariosFreelanceTodos = lisUsuariosFreelance;

      this.lisBasesFreelanceTodos.forEach(baseFreelance => {
        this.lisBasesFreelance.push({ label: baseFreelance.nombre, value: baseFreelance.idLista });
      });
      this.lisUsuariosFreelanceTodos.forEach(usuarioFreelance => {
        this.lisUsuariosFreelance.push({ label: usuarioFreelance.usuarioSistema, value: usuarioFreelance.idUsuario });
      });

      this.cargarFormulario();
      this.carInformacionInicial = false;
    });
  }

  get f() { return this.formulario.controls }

  abrirAcordeon(evento: any) {
    switch (evento.index) {
      case 0: {
        this.tabSeleccionado = "INFO";
        break;
      }
      case 1: {
        this.tabSeleccionado = "TARIF";
        break;
      }
      default: {
        break;
      }
    }
  }

  async onSubmit() {
    this.submitted = true;
    const usuarioComisionFreelance = this.formulario.value;
    this.guardando = true;
    if (this.formulario.valid && await this.validarUsuarioFreelance()) {
      this.guardarUsuarioComisionFreelance(usuarioComisionFreelance);
    } else {
      this.guardando = false;
    }
  }

  async validarUsuarioFreelance() {
    // valida el usuario freelance si ya esta creado o no en comision freelance
    if (this.comisionFreelance) {
      return true;
    }
    if (await this.comisionFreelanceService.validarExisteUsuarioComision(this.f.idUsuarioFreelance.value).toPromise()) {
      this.navService.setMesage(0, {
        severity: 'info', summary: this.navService.buscarMensaje('LBL_INFORMACION'),
        detail: this.navService.buscarMensaje('USUARIOCOMISIONFREELANCE.MSG_INFOYAEXISTEUSUARIOCOMISION')
      });
      return false;
    }
    return true;
  }

  validarModificacionFormulario(objeto: UsuarioComisionFreelance) {
    if (!objeto) {
      return;
    }

    if (Number(objeto.porcentajeComision) !== Number(this.f.porcentajeComision.value)) {
      this.emitir();
    }
  }

  emitir() {
    this.communicationService.emitir({
      canal: CanalComunicacion.ACTUALIZARTARIFAS,
      mensaje: true,
    });
  }

  guardarUsuarioComisionFreelance(usuarioComisionFreelance: UsuarioComisionFreelance) {
    usuarioComisionFreelance.porcentajeComision = Number(usuarioComisionFreelance.porcentajeComision);
    if (usuarioComisionFreelance.idUsuarioComisionFreelance) {
      this.comisionFreelanceService.actualizarEspecialComisiones(usuarioComisionFreelance).subscribe(rta => {
        this.navService.setMesage(1);
        this.validarModificicaciones(this.comisionFreelance);
        const objeto = this.comisionFreelance;
        this.comisionFreelance = rta;
        const usuario = this.lisUsuariosFreelanceTodos.find((x) => x.idUsuario === this.comisionFreelance.idUsuarioFreelance)
        this.comisionFreelance.usuarioSistema = usuario ? usuario.usuarioSistema : null;
        this.validarModificacionFormulario(objeto);
        this.tabSeleccionado = 'TARIF';
        this.guardando = false;
      }, error => {
        this.navService.setMesage(3);
        this.guardando = false;
      });
    } else {
      this.comisionFreelanceService.crear(usuarioComisionFreelance).subscribe(rta => {
        this.navService.setMesage(1);
        this.comisionFreelance = rta;
        const usuario = this.lisUsuariosFreelanceTodos.find((x) => x.idUsuario === this.comisionFreelance.idUsuarioFreelance)
        this.comisionFreelance.usuarioSistema = usuario ? usuario.usuarioSistema : null;
        this.validarModificicaciones(this.comisionFreelance, true);
        this.comisionFreelance.idUsuarioComisionFreelance = rta.idUsuarioComisionFreelance;
        this.f.idUsuarioComisionFreelance.setValue(rta.idUsuarioComisionFreelance);
        this.tabSeleccionado = 'TARIF';
        this.guardando = false;
      }, error => {
        this.navService.setMesage(3);
        this.guardando = false;
      });
    }
  }

  validarModificicaciones(usuarioComisionFreelance: UsuarioComisionFreelance = null, nuevo: boolean = false) {
    let usuarioComisionFreelanceHistorico = {} as UsuarioComisionFreelanceHistorico;
    usuarioComisionFreelanceHistorico.idUsuarioComisionFreelance = usuarioComisionFreelance.idUsuarioComisionFreelance;
    if (nuevo) {
      usuarioComisionFreelanceHistorico.datoNuevo = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCE.LBL_COMISION') + ': ' + this.f.porcentajeComision.value;
      this.lisUsuarioComisionFreelanceHistorico.push(Object.assign({}, usuarioComisionFreelanceHistorico));
      usuarioComisionFreelanceHistorico.datoNuevo = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCE.LBL_BASE') + ': ' + this.lisBasesFreelanceTodos.find((x) => x.idLista === this.f.idBaseFreelance.value).nombre;
      this.lisUsuarioComisionFreelanceHistorico.push(Object.assign({}, usuarioComisionFreelanceHistorico));
      this.guardarUsuariosComisionFreelanceHistorico();
      return;
    }

    if (usuarioComisionFreelance.porcentajeComision === this.f.porcentajeComision.value &&
      usuarioComisionFreelance.idBaseFreelance === this.f.idBaseFreelance.value) {
      return;
    }

    if (usuarioComisionFreelance.porcentajeComision !== this.f.porcentajeComision.value) {
      usuarioComisionFreelanceHistorico.datoAnterior = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCE.LBL_COMISION') + ': ' + usuarioComisionFreelance.porcentajeComision;
      usuarioComisionFreelanceHistorico.datoNuevo = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCE.LBL_COMISION') + ': ' + this.f.porcentajeComision.value;
      this.lisUsuarioComisionFreelanceHistorico.push(Object.assign({}, usuarioComisionFreelanceHistorico));
    }

    if (usuarioComisionFreelance.idBaseFreelance !== this.f.idBaseFreelance.value) {
      usuarioComisionFreelanceHistorico.datoAnterior = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCE.LBL_BASE') + ': ' + this.lisBasesFreelanceTodos.find((x) => x.idLista === usuarioComisionFreelance.idBaseFreelance).nombre;
      usuarioComisionFreelanceHistorico.datoNuevo = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCE.LBL_BASE') + ': ' + this.lisBasesFreelanceTodos.find((x) => x.idLista === this.f.idBaseFreelance.value).nombre;
      this.lisUsuarioComisionFreelanceHistorico.push(Object.assign({}, usuarioComisionFreelanceHistorico));
    }

    this.guardarUsuariosComisionFreelanceHistorico();
  }

  async guardarUsuariosComisionFreelanceHistorico() {
    if (this.lisUsuarioComisionFreelanceHistorico.length === 0) {
      return;
    }
    await this.usuariosComisionesFreelanceHistoricosService.bulk(this.lisUsuarioComisionFreelanceHistorico).toPromise();
    this.lisUsuarioComisionFreelanceHistorico = [];
  }

  regresar(dirty: boolean) {
    if (dirty) {
      this.conServicio.confirm({
        message: this.navService.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      });
    } else {
      this.location.back();
    }
  }

  cambiarTabSeleccionado(tab: string) {
    this.tabSeleccionado = tab;
  }
}
